import {ComponentLink, Link, makeChain} from "@Common/react/cst2";
import {UseState}                       from "@Common/react/use-state";

import {EnlargedView} from "@Xpresso/routes/common/enlarged-view/enlarged-view";

export const ThumbnailPreviewModal = ({renderSibling}:{
    renderSibling: Link<JSX.Element, {
        show: (images:Parameters<typeof EnlargedView>[0]['images']) => void,
    }>
}) => (
    makeChain<JSX.Element>()
    .then("state", ({}, next:ComponentLink<typeof UseState<{images: Parameters<typeof EnlargedView>[0]['images'], index: number, show: boolean}>>) => (
        UseState({next, initValue: {images: [], index: 0, show: false}})
    ))
    .then("enlargedView", (({state}, next:ComponentLink<typeof EnlargedView>) => 
        EnlargedView({
            next,
            modalState   : state,
            images       : state.value.images,
            onChangeView : (index) => state.onChange({...state.value, index}),
            viewing      : state.value.index,
        })
    ))
    .then(({state: {onChange: setState}}) => renderSibling({
        show: (images) => setState({images, index: 0, show: true}),
    }))
    .run()
);

